import {
  Box,
  Flex,
  Text,
  IconButton,
  Stack,
  Collapse,
  Select,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react'
import { HamburgerIcon, CloseIcon, ExternalLinkIcon } from '@chakra-ui/icons'

import { useDispatch, useSelector } from 'react-redux'
import { signOutAction } from '../../redux/actions/auth.action'
import {
  setType,
  setDeformationRateIntervalValue,
} from '../../redux/actions/map.actions'
export default function WithSubnavigation() {
  const { isOpen, onToggle } = useDisclosure()
  const dispatch = useDispatch()
  const { verifyTokenPending, isAuthenticated } = useSelector(
    (state) => state.authStates,
  )

  // const { user } = useSelector((state) => state.authStates)

  const onSignOut = () => {
    dispatch(signOutAction())
  }

  const onSelectDeformationRateIntervalValue = (e) => {
    dispatch(setDeformationRateIntervalValue(e.target.value))
  }

  const onSelectType = (e) => {
    dispatch(setType(e.target.value))
  }

  return (
    <Box>
      <Flex
        bg={'teal.500'}
        minH={'60px'}
        py={{ base: 2 }}
        px={{ base: 4 }}
        borderBottom={1}
        align={'center'}
      >
        <Flex
          flex={{ base: 1, md: 'auto' }}
          ml={{ base: -2 }}
          display={{ base: 'flex', md: 'none' }}
        >
          <IconButton
            bg="teal.500"
            onClick={onToggle}
            _hover={{ bg: 'teal.500' }}
            _active={{ bg: 'teal.500' }}
            icon={
              isOpen ? (
                <CloseIcon color="white" w={3} h={3} />
              ) : (
                <HamburgerIcon color="white" w={5} h={5} />
              )
            }
            variant={'ghost'}
            aria-label={'Toggle Navigation'}
          />
        </Flex>
        <Flex flex={{ base: 'none', md: 1 }}>
          <Text
            fontSize={{ base: 'md', md: 'lg' }}
            fontWeight="bold"
            color="white"
          >
            GeoSES InSAR Web Viewer
          </Text>
        </Flex>

        <Stack
          flex={{ base: 1, md: 0 }}
          justify={'flex-end'}
          direction={'row'}
          spacing={6}
        >
          {isAuthenticated && !verifyTokenPending ? (
            <>
              <Select
                bg="white"
                display={{ base: 'none', md: 'block' }}
                ml={50}
                width={'100px'}
                onChange={onSelectType}
              >
                <option value="LOS">LOS</option>
                <option value="UP">UP</option>
              </Select>
              <Select
                bg="white"
                display={{ base: 'none', md: 'block' }}
                width={'300px'}
                onChange={onSelectDeformationRateIntervalValue}
              >
                <option value="0"> {'All points'}</option>
                <option value="1">{'-0.005 m > deformation < +0.005 m'}</option>
                <option value="2">{'-0.01 m  > deformation < +0.01 m'}</option>
                <option value="3">
                  {'deformation < -0.01 m; deformation > +0.01 m'}
                </option>
                <option value="4">
                  {'deformation < -0.02 m; deformation > +0.02 m'}
                </option>
              </Select>
              <IconButton
                onClick={onSignOut}
                aria-label="Sign Out"
                bg="none"
                _hover={{ bg: 'none' }}
                color="white"
                icon={<ExternalLinkIcon width={6} height={6} />}
              />
            </>
          ) : null}
        </Stack>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav
          onSelectDeformationRateIntervalValue={
            onSelectDeformationRateIntervalValue
          }
          onSelectType={onSelectType}
        />
      </Collapse>
    </Box>
  )
}

const MobileNav = (onSelectDeformationRateIntervalValue, onSelectType) => {
  return (
    <Stack
      bg={useColorModeValue('white', 'gray.800')}
      p={4}
      display={{ base: 'flex-row' }}
    >
      <Select bg="white" width={'100px'} onChange={onSelectType}>
        <option value="LOS">LOS</option>
        <option value="UP">UP</option>
      </Select>
      <Select wid bg="white" onChange={onSelectDeformationRateIntervalValue}>
        <option value="0"> {'All points'}</option>
        <option value="1">{'-0.005 m > deformation < +0.005 m'}</option>
        <option value="2">{'-0.01 m  > deformation < +0.01 m'}</option>
        <option value="3">
          {'deformation < -0.01 m; deformation > +0.01 m'}
        </option>
        <option value="4">
          {'deformation < -0.02 m; deformation > +0.02 m'}
        </option>
      </Select>
    </Stack>
  )
}
